"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _TableCell = _interopRequireDefault(require("./TableCell"));

var _Typography = require("../../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextTableCell = function TextTableCell(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var fontSize = props.fontSize,
      color = props.color,
      tableCellProps = _objectWithoutProperties(props, ["fontSize", "color"]);

  var textProps = {
    fontSize: fontSize,
    color: color
  };
  return _react["default"].createElement(_TableCell["default"], tableCellProps, _react["default"].createElement(_Typography.Text, textProps, children));
};

TextTableCell.defaultProps = {
  theme: _theme["default"],
  fontSize: 0
};
var _default = TextTableCell;
exports["default"] = _default;